const ROLE_LABELS: Record<string, string> = {
  org_admin: 'Admin',
  org_default: 'Member',
  org_member: 'Member',
  org_viewer: 'Viewer',
  project_member: 'Project Member',
  project_admin: 'Admin',
  project_editor: 'Editor',
  project_viewer: 'Viewer',
}

export const roleLabel = (role?: string): string => ROLE_LABELS[role ?? ''] ?? role ?? ''
